import React from 'react';
import premium1 from './assets/images/go-premium-1.png';
const NewsFeed = () => {
  return (
    // <!-- Newsfeed -->
    <section id="newsfeed" className="newsfeed section">
      <div className="container">
        <div className="row gx-4 gy-5 gx-lg-5">
          <div className="col-xl-6">
            <p className="section__para one" data-aos="fade-up">#LATEST</p>
            <h2 className="heading__1" data-aos="fade-up">Newsfeed</h2>
            <p className="section__para two" data-aos="fade-up">
              News & Update
            </p>
            <p className="para" data-aos="fade-up">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
              do eiusmod tempor incididunt ut labore et dolore magna aliqua.
              Ut enim ad minim veniam, quis nostrud exercitation ullamco
              laboris nisi ut aliquip ex ea commodo consequat.
            </p>
            <div className="latest__posts" data-aos="fade-up">
          
               
<div className='grid lg:grid-cols-3 gap-4'>
                    <div className="splide__track">
                      <ul className="splide__list">
                        <li className="splide__slide">

                <div className="card w-60">
                    <div className="card-box">
                      <div className="card-box__img">
                        <img
                          src={premium1}
                          alt="News"
                          width="210"
                          height="101"
                          className="img-fluid"
                        />
                      </div>
                      <div className="card-box__body">
                        <div className="meta">
                          <div className="user">
                            <i className="fa-solid fa-circle-user"></i>
                            <a href="#" className="username">By Lorem</a>
                          </div>
                          |
                          <div className="date">
                            <i className="fa-solid fa-calendar-days"></i>
                            <a href="#" className="text">April 21, 2022</a>
                          </div>
                        </div>
                        <p className="card-box__text">
                          Lorem ipsum dolor sit, amet consectetur
                          adipisicing elit. Cum, quisquam!
                        </p>
                        <a href="#" className="readmore">
                          <span className="text">Read More</span>
                          <i className="fa-solid fa-arrow-right"></i>
                        </a>
                      </div>
                    </div>
                </div>
                </li>
                      </ul>
                    </div>
                    <div className="splide__track">
                      <ul className="splide__list">
                        <li className="splide__slide">


        
                <div className="card w-60">
                    <div className="card-box">
                      <div className="card-box__img">
                        <img
                          src={premium1}
                          alt="News"
                          width="210"
                          height="101"
                          className="img-fluid"
                        />
                      </div>
                      <div className="card-box__body">
                        <div className="meta">
                          <div className="user">
                            <i className="fa-solid fa-circle-user"></i>
                            <a href="#" className="username">By Lorem</a>
                          </div>
                          |
                          <div className="date">
                            <i className="fa-solid fa-calendar-days"></i>
                            <a href="#" className="text">April 21, 2022</a>
                          </div>
                        </div>
                        <p className="card-box__text">
                          Lorem ipsum dolor sit, amet consectetur
                          adipisicing elit. Cum, quisquam!
                        </p>
                        <a href="#" className="readmore">
                          <span className="text">Read More</span>
                          <i className="fa-solid fa-arrow-right"></i>
                        </a>
                      </div>
                    </div>
                </div>
                </li>
                      </ul>
                    </div>
                    <div className="splide__track">
                      <ul className="splide__list">
                        <li className="splide__slide">


        
                <div className="card w-60">
                    <div className="card-box">
                      <div className="card-box__img">
                        <img
                          src={premium1}
                          alt="News"
                          width="210"
                          height="101"
                          className="img-fluid"
                        />
                      </div>
                      <div className="card-box__body">
                        <div className="meta">
                          <div className="user">
                            <i className="fa-solid fa-circle-user"></i>
                            <a href="#" className="username">By Lorem</a>
                          </div>
                          |
                          <div className="date">
                            <i className="fa-solid fa-calendar-days"></i>
                            <a href="#" className="text">April 21, 2022</a>
                          </div>
                        </div>
                        <p className="card-box__text">
                          Lorem ipsum dolor sit, amet consectetur
                          adipisicing elit. Cum, quisquam!
                        </p>
                        <a href="#" className="readmore">
                          <span className="text">Read More</span>
                          <i className="fa-solid fa-arrow-right"></i>
                        </a>
                      </div>
                    </div>
                </div>
                </li>
                      </ul>
                    </div>
      
             </div>
             </div>
          </div>


           {/*  */}
          <div className="col-xl-6" data-aos="fade-up">
            <div className="feature__post">
              <div className="card-box">
                <div className="card-box__img">
                  <img
                    src={premium1}
                    alt="News"
                    width="210"
                    height="101"
                    className="img-fluid"
                  />
                </div>
                <div className="card-box__body">
                  <div className="meta">
                    <div className="user">
                      <i className="fa-solid fa-circle-user"></i>
                      <a href="#" className="username">By Lorem</a>
                    </div>
                    |
                    <div className="date">
                      <i className="fa-solid fa-calendar-days"></i>
                      <a href="#" className="text">April 21, 2022</a>
                    </div>
                  </div>
                  <h4 className="card-box__title">Website Development</h4>
                  <p className="card-box__text">
                    Lorem ipsum dolor sit amet, consectetur adipisicing
                    elit. Suscipit repellendus, minus doloremque eaque
                    asperiores cumque voluptatum, explicabo doloribus
                    obcaecati iste nostrum animi voluptas harum accusamus
                    sapiente quam, sunt cum laborum.
                  </p>
                  <a href="#" className="readmore">
                    <span className="text">Read More</span>
                    <i className="fa-solid fa-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    // <!-- Newsfeed -->
  );
};

export default NewsFeed;